import axios from "axios";
import ENV from "../../../../../envProperties";

window.log("process.env", process.env);

const PROTOCOL = "https";
const HOST = ENV.API_PORTAL_AWS;

const HTTP_REQUEST_HEADER = {
  "Accept-Language": "pt-BR",
  "Content-Type": "application/json",
};

export const BASE_URL = `${PROTOCOL}://${HOST}`;

const instance = axios.create({
  baseURL: BASE_URL,
  headers: HTTP_REQUEST_HEADER,
});

const interceptors = { request: [], response: [] };

export default { client: instance, options: { interceptors } };



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/clients/portalAws.js